export default "__VITE_ASSET__d7bbff73__"